/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {AxiosResponse} from "axios";

type PartnersType = {
	partnersCode: string;
};

const initialState: PartnersType = {
	partnersCode: "",
};

const asyncPartnersCodeFetch = createAsyncThunk("goods/asyncPartnersCodeFetch", async (partnersName: string) => {
	const res: AxiosResponse = await useConfigureAxios(`/prdt/api/common/code/partners/bc`);
	return res;
});

const sliceStore = createSlice({
	name: "partners",
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(asyncPartnersCodeFetch.pending, (state, action: PayloadAction<AxiosResponse>) => {});
		builder.addCase(asyncPartnersCodeFetch.fulfilled, (state, action: PayloadAction<AxiosResponse>) => {
			state.partnersCode = action.payload.data.body;
		});
		builder.addCase(asyncPartnersCodeFetch.rejected, (state, action: PayloadAction<Object>) => {});
	},
});

export {asyncPartnersCodeFetch};
export default sliceStore.reducer;
